module.exports = __webpack_public_path__ + "img/standard-definition.6fc44902.svg";